import { QuoteStatusId } from '@models/quotes';

export const quoteStatuses = [
  QuoteStatusId.Submission,
  QuoteStatusId.ReadyForRating,
  QuoteStatusId.Rated,
  QuoteStatusId.Referred,
  QuoteStatusId.ReadyToBind,
];

export const cancelDeclineQuoteStatuses = [...quoteStatuses, QuoteStatusId.Underwritten, QuoteStatusId.Expired];

export enum TabValue {
  Quotes = 0,
  Renewals = 1,
  Indications = 2,
}

export enum QuoteDataGridType {
  UWHomePageAllTransaction = 'UWHomePageAllTransaction',
  UWHomePageRecentlyViewed = 'UWHomePageRecentlyViewed',
  UWHomePageNewBusiness = 'UWHomePageNewBusiness',
  UWHomePageRenewals = 'UWHomePageRenewals',
  UWHomePageEndorsements = 'UWHomePageEndorsements',
  QuoteTypeRenewal = 'QuoteTypeRenewal',
  QuoteTypeNewBusiness = 'QuoteTypeNewBusiness',
}

export const UnderwriterHomePageTabs = [
  QuoteDataGridType.UWHomePageAllTransaction,
  QuoteDataGridType.UWHomePageRecentlyViewed,
  QuoteDataGridType.UWHomePageNewBusiness,
  QuoteDataGridType.UWHomePageRenewals,
  QuoteDataGridType.UWHomePageEndorsements,
];
